export const environment = {
  envName: 'test',
  production: true,
  enableSEO: false,
  sentryLogging: true,
  apiUrl: typeof window === 'undefined' ? 'http://klubovna-api-test:3000/api' : 'https://test.klubovnasl.sk/api',
  appUrl: 'https://test.klubovnasl.sk',
  consoleUrl: 'https://app-test.klubovnasl.sk',
  staticContentUrl: 'https://s3.klubovnasl.sk/klubovna-test-public',
};
